import { render, staticRenderFns } from "./shop-product-coupons.vue?vue&type=template&id=2e64a2f3&"
import script from "./shop-product-coupons.vue?vue&type=script&lang=js&"
export * from "./shop-product-coupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports